import { formatNumberByUserDataFormatOrFallback, IUserDataFormatSettings } from "@framework/types";

interface IFormatMeasurementNumberOptions {
  fallbackDigits?: number;
}

interface IFormatSchemeControlMeasurementValueOptions extends IFormatMeasurementNumberOptions {
  bindObjectType: number | null | undefined;
  componentName: string | null | undefined;
  rawValue: number | null | undefined;
  settings: IUserDataFormatSettings | null | undefined;
  sourceValue: string | null | undefined;
  valueUnits: number | string | null | undefined;
}

const MEASUREMENT_BIND_OBJECT_TYPE = 4;

export function formatMeasurementNumber(
  value: number | null | undefined,
  unitCode: number | string | null | undefined,
  settings: IUserDataFormatSettings | null | undefined,
  options: IFormatMeasurementNumberOptions = {},
): string {
  return formatNumberByUserDataFormatOrFallback(value, unitCode, settings, options);
}

export function replaceLeadingNumericValue(source: string | null | undefined, formattedNumber: string): string {
  if (!source) {
    return formattedNumber;
  }

  const leadingWhitespace = source.match(/^\s*/u)?.[0] ?? "";
  const sourceBody = source.slice(leadingWhitespace.length);
  const numericPrefixMatch = sourceBody.match(/^[-+]?\d+(?:[.,]\d+)?/u);

  if (!numericPrefixMatch) {
    return formattedNumber;
  }

  return `${leadingWhitespace}${formattedNumber}${sourceBody.slice(numericPrefixMatch[0].length)}`;
}

export function formatSchemeControlMeasurementValue(
  options: IFormatSchemeControlMeasurementValueOptions,
): string | null {
  const { bindObjectType, componentName, rawValue, settings, sourceValue, valueUnits, fallbackDigits } = options;
  const baseValue = sourceValue ?? null;

  if (
    bindObjectType !== MEASUREMENT_BIND_OBJECT_TYPE ||
    rawValue === null ||
    rawValue === undefined ||
    !Number.isFinite(rawValue)
  ) {
    return baseValue;
  }

  const formattedNumber = formatMeasurementNumber(rawValue, valueUnits, settings, {
    fallbackDigits: fallbackDigits ?? (componentName === "TiSevenSegmentAnalog" ? 2 : 1),
  });

  return replaceLeadingNumericValue(baseValue, formattedNumber);
}
